export default function CTABanner() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20glowing%20amber%20glass%20shelves%20in%20a%20minimalist%20boutique%20displaying%20curated%20fashion%20items%20as%20silhouettes%20against%20backlit%20frosted%20panels%2C%20luxury%20retail%20interior%20photography%2C%20rich%20golden%20hour%20light%20streaming%20through%20floor%20to%20ceiling%20windows%2C%20sophisticated%20warm%20cognac%20and%20honey%20tones%2C%20elegant%20commercial%20space%20with%20atmospheric%20depth%20and%20soft%20reflections&width=1800&height=900&seq=cta-v2-fresh1&orientation=landscape"
          alt="GTBuy Spreadsheet Hub - Access verified categories"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div>
            <h2 className="text-background-50 font-heading text-5xl md:text-6xl lg:text-7xl font-light lowercase leading-none">
              access verified hub
            </h2>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 bg-background-50 text-foreground-900 px-7 py-3.5 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer group mt-8"
            >
              Go to Main Store
              <span className="w-7 h-7 flex items-center justify-center bg-foreground-900 rounded-full group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </a>
          </div>

          <div className="text-background-50/80 text-base font-light leading-relaxed max-w-sm">
            <p>All external links open in new tabs.</p>
            <p>Compare 14 categories updated daily.</p>
          </div>
        </div>
      </div>
    </section>
  );
}